<script>
import forminput from "@/router/views/formcomponet/forminput.vue";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import opersonel from "@/models/opersonel";
import useVuelidate from "@vuelidate/core";
import treeselect from "vue3-treeselect";
import "vue3-treeselect/dist/vue3-treeselect.css";
export default {
  mixins: [Api, Sabit, opersonel],
  page: {
    title: "Profilim",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader, forminput, treeselect
  },
  data() {
    return {
      title: "Profilim",
      items: [
        {
          text: "Anasayfa",
          href: "/",
        },
        {
          text: "Profilim",
          active: true,
        },
      ],

      v$: useVuelidate(),
      FormData: {},
      FormDataPassword: {}
    };
  },

  methods: {
    Get() {



    },
    async onSubmit() {
      this.v$.FormData.$touch();
      if (!this.v$.FormData.$invalid) {
        this.Update("opersonel", this.FormData)
      }
    },
    async onSubmitPassword() {
      this.v$.FormDataPassword.$touch();
      if (!this.v$.FormDataPassword.$invalid) {

          if(this.FormDataPassword.Password == this.FormDataPassword.ConfirmPassword){
              this.FormDataPassword.Email = this.TokenEmail
              this.FormDataPassword.Token = this.JWToken

              this.ResetPasswordLogin(this.FormDataPassword).then((res) => { 
                  if (res.Succeeded == true) {
                    this.$toast.success(res.Message);
                    this.FormDataPassword.Password = null
                    this.FormDataPassword.ConfirmPassword = null
                  } else {
                    this.$toast.error(res.Message);
                  }
                }); 
          }
          else{
            this.$toast.error("Şifreler aynı olmalıdır.");
          }
      }
    },


    
  },
  created() {
    this.ActionsFilterGet({
      Service: "opersonel",
      FullData: true,
      Filter: "&Id=" + this.TokenPersonelId,
    }).then((res) => {
      this.FormData = res.Data[0];
    });
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />



    <b-tabs justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">

      <b-tab>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="fas fa-home"></i>
          </span>
          <span class="d-none d-sm-inline-block"> Kullanıcı Bilgileri Düzenle
          </span>
        </template>


        <div class="row">
          <div class="col-xl-12">
            <div class="card">
              <div class="card-body">

                <Form @submit.prevent="onSubmit" v-if="FormData">
                  <div class="row">
                    <forminput class="col-lg-6" :FormDataType="FormDataType.Adsoyad" :Value="FormData.Adsoyad"
                      :v="v$.FormData.Adsoyad" @input="FormData.Adsoyad = $event.target.value" />
                    <b-form-group class="col-lg-6" label-for="text" :label="FormDataType.Birimid.FieldTitle"
                      :key="FormData.Birimid">
                      <treeselect :multiple="false" :options="FormDataType.Birimid.ComboDataArray"
                        placeholder="Seçiniz..." v-model="FormData.Birimid" />
                      <treeselect-value :value="FormData.Birimid" />
                    </b-form-group>

                    <forminput class="col-lg-6" :FormDataType="FormDataType.Eposta" :Value="FormData.Eposta"
                      :v="v$.FormData.Eposta" @input="FormData.Eposta = $event.target.value" />
                    <forminput class="col-lg-6" :FormDataType="FormDataType.Telefon" :Value="FormData.Telefon"
                      :v="v$.FormData.Telefon" @input="FormData.Telefon = $event.target.value" />
 
                    <forminput class="col-lg-6" :FormDataType="FormDataType.Tckimlikno" :Value="FormData.Tckimlikno"
                      :v="v$.FormData.Tckimlikno" @input="FormData.Tckimlikno = $event.target.value" />
                  </div>

                  <button class="btn btn-primary" type="submit">
                    Güncelle
                  </button>
                </Form>

              </div>
            </div>
          </div>
        </div>

      </b-tab>


      <b-tab>
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="fas fa-home"></i>
          </span>
          <span class="d-none d-sm-inline-block"> Şifre Bilgilerimi Düzenle
          </span>
        </template>



        <div class="row">
          <div class="col-xl-12">
            <div class="card">
              <div class="card-body">


                <Form @submit.prevent="onSubmitPassword" v-if="FormData">
                  <div class="row">  
                    <forminput class="col-lg-6" :FormDataType="FormDataType.Password" :Value="FormDataPassword.Password"
                      :v="v$.FormDataPassword.Password" @input="FormDataPassword.Password = $event.target.value" />

                    <forminput class="col-lg-6" :FormDataType="FormDataType.ConfirmPassword" :Value="FormDataPassword.ConfirmPassword"
                      :v="v$.FormDataPassword.ConfirmPassword" @input="FormDataPassword.ConfirmPassword = $event.target.value" />
 
                  </div>

                  <button class="btn btn-primary" type="submit">
                    Güncelle
                  </button>
                </Form>

              </div>
            </div>
          </div>
        </div>

      </b-tab>
    </b-tabs>
  </Layout>

</template>
